import React from 'react';

import Link from './Link';
import {StarIcon} from './svg';
import {cx, formatLargeNum} from '../util';

export const KarmaPillSizes = {
  REGULAR: 'regular',
  LARGE: 'large',
  XLARGE: 'xlarge',
};

const KarmaPill = ({
  score,
  size = KarmaPillSizes.REGULAR,
  outline = false,
  verbose = false,
  // Rounded-rectangle variant that sizes itself to match adjacent buttons
  // (the top bar CTA row): square-ish corners, horizontal padding only, and
  // the height left to the consumer's className.
  rect = false,
  title,
  onClick,
  className,
}) => (
  <Link
    className={cx('flex items-center',
      rect ? 'cursor-pointer rounded-lg px-2.5 transition-colors hover:bg-gray-50' : 'rounded-full',
      {
        'py-1 pl-2 pr-3': !rect && size === KarmaPillSizes.XLARGE,
        'py-0.5 pl-1.5 pr-2': !rect && size !== KarmaPillSizes.XLARGE,
        'bg-gray-50': !outline,
        'bg-white border border-gray-200': outline,
      },
      className)}
    href="/karma"
    // Explicit null suppresses the native tooltip, for consumers that render
    // their own styled one.
    title={title === undefined ? `${score ? score.toLocaleString() : '0'} karma` : title || undefined}
    aria-label={`View karma details. Current karma ${score ? score.toLocaleString() : '0'}`}
    onClick={onClick}
  >
    <StarIcon
      className={cx('text-yellow-400',
        {
          'h-5 w-5 mr-1': size === KarmaPillSizes.XLARGE,
          'h-4 w-4 mr-0.5': size === KarmaPillSizes.LARGE,
          'h-3.5 w-3.5 mr-0.5': size === KarmaPillSizes.REGULAR,
        })}
      aria-hidden="true"
    />
    <span className={cx('font-medium text-gray-400',
      {
        'text-base font-semibold': size === KarmaPillSizes.XLARGE,
        'text-sm': size === KarmaPillSizes.LARGE,
        'text-xs': size === KarmaPillSizes.REGULAR,
      })}
    >
      {verbose && '+'}
      {formatLargeNum(score)}
    </span>
  </Link>
);

export default KarmaPill;
